
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title 
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Yuge Aththavis Vitevari Ubha" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Yuge Aththavis Vitevari Ubha" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Yuge Aththavis Vitevari Ubha, Vithalachi Aarti, Panduranga Aarti, Panduranga Aarti, Shri Vitthal Aarti, Shri Vitthal Aarti lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Yuge Aththavis Vitevari Ubha, Vithalachi Aarti, विठोबाची आरती, Panduranga Aarti, Marathi Aarti Lyrics, Shri Vitthal Aarti, Vitthal Rakhumai Aarti, Vithalachi Aarti Lyrics in Marathi and English, Aarti of Lord Vithoba, Pundalik Vitthal Aarti, Panduranga Devotional aarti, yuge atthavis vitevari ubha lyrics, yuge atthavis vitevari ubha lyrics in marathi, yuge atthavis vitevari ubha lyrics in english, विठ्ठलाची आरती युगे अठ्ठावीस, yuge atthavis vitevari ubha aarti'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/vithoba.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/vithoba.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title:'Yuge Aththavis Vitevari Ubha | Vithalachi Aarti - युगें अठ्ठावीस विटेवरी उभा (विठोबाची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/vithoba"
        },
        "headline": "Yuge Aththavis Vitevari Ubha - युगें अठ्ठावीस विटेवरी उभा (विठोबाची आरती)",
        "name" : "Yuge Aththavis Vitevari Ubha - Vithalachi Aarti",
        "description": "Explore the full lyrics of Aarti 'Yuge Aththavis Vitevari Ubha' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/vithoba.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }
  
    }

  